// Generated by `npm run content:build`. Do not edit manually.
import type { ArenaDefinition, CardDefinition, SpellDefinition, UnitDefinition } from '../../engine/types';

export const EXTENSION_VERSION = 'ef27acba8141';
export const EXTENSION_CARDS = [
  {
    "id": "giant-skeleton",
    "name": "ГИГАНТСКИЙ СКЕЛЕТ",
    "kind": "troop",
    "cost": 6,
    "deployTimeTicks": 30,
    "placement": "own-side",
    "roles": [
      "tank",
      "melee",
      "splash"
    ],
    "mechanics": [
      {
        "type": "spawn-units",
        "groups": [
          {
            "unitId": "giant-skeleton-unit",
            "count": 1,
            "formationRadius": 0
          }
        ]
      }
    ],
    "presentationKey": "card.giant-skeleton"
  },
  {
    "id": "goblin-barrel",
    "name": "БОЧКА С ГОБЛИНАМИ",
    "kind": "spell",
    "cost": 3,
    "deployTimeTicks": 0,
    "placement": "anywhere",
    "roles": [
      "spell",
      "swarm"
    ],
    "mechanics": [
      {
        "type": "area-projectile",
        "spellId": "goblin-barrel-spell"
      }
    ],
    "presentationKey": "card.goblin-barrel"
  },
  {
    "id": "goblin-gang",
    "name": "БАНДА ГОБЛИНОВ",
    "kind": "troop",
    "cost": 3,
    "deployTimeTicks": 30,
    "placement": "own-side",
    "roles": [
      "swarm",
      "melee",
      "ranged",
      "anti-air"
    ],
    "mechanics": [
      {
        "type": "spawn-units",
        "groups": [
          {
            "unitId": "goblin-unit",
            "count": 3,
            "formationRadius": 400,
            "staggerTicks": 2
          },
          {
            "unitId": "spear-goblin-unit",
            "count": 2,
            "formationRadius": 650,
            "staggerTicks": 2
          }
        ]
      }
    ],
    "presentationKey": "card.goblin-gang"
  },
  {
    "id": "mega-knight",
    "name": "МЕГАРЫЦАРЬ",
    "kind": "troop",
    "cost": 7,
    "deployTimeTicks": 30,
    "placement": "own-side",
    "roles": [
      "tank",
      "melee",
      "splash",
      "defense"
    ],
    "mechanics": [
      {
        "type": "spawn-units",
        "groups": [
          {
            "unitId": "mega-knight-unit",
            "count": 1,
            "formationRadius": 0
          }
        ]
      }
    ],
    "presentationKey": "card.mega-knight"
  },
  {
    "id": "minion-horde",
    "name": "ОРДА МИНЬОНОВ",
    "kind": "troop",
    "cost": 5,
    "deployTimeTicks": 30,
    "placement": "own-side",
    "roles": [
      "swarm",
      "anti-air",
      "ranged"
    ],
    "mechanics": [
      {
        "type": "spawn-units",
        "groups": [
          {
            "unitId": "minion-unit",
            "count": 6,
            "formationRadius": 560,
            "staggerTicks": 2
          }
        ]
      }
    ],
    "presentationKey": "card.minion-horde"
  },
  {
    "id": "the-log",
    "name": "БРЕВНО",
    "kind": "spell",
    "cost": 2,
    "deployTimeTicks": 0,
    "placement": "anywhere",
    "roles": [
      "spell",
      "splash",
      "defense"
    ],
    "mechanics": [
      {
        "type": "area-projectile",
        "spellId": "the-log-spell"
      }
    ],
    "presentationKey": "card.the-log"
  },
  {
    "id": "witch",
    "name": "ВЕДЬМА",
    "kind": "troop",
    "cost": 5,
    "deployTimeTicks": 30,
    "placement": "own-side",
    "roles": [
      "ranged",
      "splash",
      "anti-air",
      "swarm"
    ],
    "mechanics": [
      {
        "type": "spawn-units",
        "groups": [
          {
            "unitId": "witch-unit",
            "count": 1,
            "formationRadius": 0
          }
        ]
      }
    ],
    "presentationKey": "card.witch"
  },
  {
    "id": "wizard",
    "name": "ВОЛШЕБНИК",
    "kind": "troop",
    "cost": 5,
    "deployTimeTicks": 30,
    "placement": "own-side",
    "roles": [
      "ranged",
      "splash",
      "anti-air"
    ],
    "mechanics": [
      {
        "type": "spawn-units",
        "groups": [
          {
            "unitId": "wizard-unit",
            "count": 1,
            "formationRadius": 0
          }
        ]
      }
    ],
    "presentationKey": "card.wizard"
  }
] as unknown as CardDefinition[];
export const EXTENSION_UNITS = [
  {
    "id": "giant-skeleton-unit",
    "movement": "ground",
    "hp": 1313,
    "radius": 400,
    "mass": 11,
    "speedPerTick": 16,
    "targetMask": "ground",
    "weapon": {
      "damage": 108,
      "range": 400,
      "sight": 2500,
      "cooldownTicks": 39,
      "windupTicks": 11
    },
    "deathEffect": {
      "damage": 320,
      "radius": 1400,
      "towerDamageMultiplier": 1,
      "visualKey": "unit.giant-skeleton.death-bomb",
      "delayTicks": 20
    },
    "visualKey": "unit.giant-skeleton"
  },
  {
    "id": "goblin-unit",
    "movement": "ground",
    "hp": 79,
    "radius": 200,
    "mass": 1,
    "speedPerTick": 32,
    "targetMask": "ground",
    "weapon": {
      "damage": 47,
      "range": 250,
      "sight": 2750,
      "cooldownTicks": 33,
      "windupTicks": 8
    },
    "visualKey": "unit.goblin"
  },
  {
    "id": "mega-knight-unit",
    "movement": "ground",
    "hp": 1560,
    "radius": 420,
    "mass": 12,
    "speedPerTick": 16,
    "targetMask": "ground",
    "weapon": {
      "damage": 105,
      "range": 600,
      "sight": 2750,
      "cooldownTicks": 51,
      "windupTicks": 13,
      "splashRadius": 850
    },
    "deployEffect": {
      "damage": 210,
      "radius": 1100,
      "towerDamageMultiplier": 1,
      "visualKey": "unit.mega-knight.deploy"
    },
    "leapAttack": {
      "damage": 210,
      "radius": 850,
      "towerDamageMultiplier": 1,
      "visualKey": "unit.mega-knight.leap",
      "minRange": 1750,
      "maxRange": 2500,
      "durationTicks": 18,
      "cooldownTicks": 54
    },
    "visualKey": "unit.mega-knight"
  },
  {
    "id": "spear-goblin-unit",
    "movement": "ground",
    "hp": 75,
    "radius": 180,
    "mass": 1,
    "speedPerTick": 32,
    "targetMask": "air-ground",
    "weapon": {
      "damage": 32,
      "range": 2000,
      "sight": 2750,
      "cooldownTicks": 51,
      "windupTicks": 10,
      "projectileSpeed": 187
    },
    "visualKey": "unit.spear-goblin"
  },
  {
    "id": "witch-unit",
    "movement": "ground",
    "hp": 328,
    "radius": 270,
    "mass": 3,
    "speedPerTick": 16,
    "targetMask": "air-ground",
    "weapon": {
      "damage": 53,
      "range": 2750,
      "sight": 2750,
      "cooldownTicks": 33,
      "windupTicks": 11,
      "projectileSpeed": 173,
      "splashRadius": 450
    },
    "periodicSpawn": {
      "groups": [
        {
          "unitId": "skeleton-unit",
          "count": 4,
          "formationRadius": 580,
          "staggerTicks": 2
        }
      ],
      "initialDelayTicks": 60,
      "intervalTicks": 210
    },
    "visualKey": "unit.witch"
  },
  {
    "id": "wizard-unit",
    "movement": "ground",
    "hp": 295,
    "radius": 260,
    "mass": 3,
    "speedPerTick": 16,
    "targetMask": "air-ground",
    "weapon": {
      "damage": 110,
      "range": 2750,
      "sight": 2750,
      "cooldownTicks": 42,
      "windupTicks": 11,
      "projectileSpeed": 173,
      "splashRadius": 750
    },
    "visualKey": "unit.wizard"
  }
] as unknown as UnitDefinition[];
export const EXTENSION_SPELLS = [
  {
    "id": "goblin-barrel-spell",
    "damage": 0,
    "radius": 0,
    "travelTicks": 24,
    "targetMask": "all-enemies",
    "towerDamageMultiplier": 0,
    "visualKey": "spell.goblin-barrel",
    "behavior": {
      "type": "spawn-units",
      "groups": [
        {
          "unitId": "goblin-unit",
          "count": 3,
          "formationRadius": 430,
          "staggerTicks": 2
        }
      ]
    }
  },
  {
    "id": "the-log-spell",
    "damage": 120,
    "radius": 650,
    "travelTicks": 17,
    "targetMask": "all-enemies",
    "towerDamageMultiplier": 0.25,
    "visualKey": "spell.the-log",
    "behavior": {
      "type": "line-damage",
      "distance": 4000,
      "speedPerTick": 240,
      "knockback": 750,
      "targetMovement": "ground"
    }
  }
] as unknown as SpellDefinition[];
export const EXTENSION_ARENAS = [] as unknown as ArenaDefinition[];
